import { InventoryTimelineComponent } from './inventory-timeline.component';
import { InventoryManagementComponent } from './../../inventory-management.component';
import { CoreModule } from './../../../core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [
    InventoryTimelineComponent
  ],
  entryComponents: [
    InventoryTimelineComponent
  ],
  exports: [
    InventoryTimelineComponent
  ],
  providers: []
})
export class InventoryTimelineModule { }
